import React, {Component} from 'react'
import LocalStorage from '../../../../util/localStorage'
import {Field, FieldsManager} from '../../../../data/services/fields'
import Resources from '../../../../data/services/resources'
import {CREATE_PERM, DEFAULT_CRUD_STATE, DELETE_PERM, UPDATE_PERM} from '../../../../util/util-constants'
import {checkPerm, getProp, mergeDeep} from '../../../../common/util/util-helpers'
import {
    createSecondResource,
    deleteSecondResource,
    getSecondResource,
    updateSecondResource
} from "../../../../data/actions/secondResource";
import {MinusCircleIcon, PlusCircleIcon} from "@heroicons/react/20/solid";
import {PencilIcon, TrashIcon} from "@heroicons/react/24/outline";
import {fillFieldsFromData} from "../../../../common/util/util-fields";
import PageHeader from "../../../../common/components/layout/layout-components/page/page-header";
import Card from "../../../../common/components/card";
import NoRecordsTable from "../../../../common/components/no-records-found/no-records-table";
import ResourceTable from "../../../../common/components/resource-table";
import ModalSaveResource from "../../../../common/components/modal/modal-save-resource";
import ModalConfirm from "../../../../common/components/modal/modal-confirm";
import {formatMoney, numberWithCommas} from "../../../../common/util/util-formaters";
import InfoParagraph from "../../../../common/components/info-paragraph";
import {Link} from "react-router-dom";
import {toFrontDate} from "../../../../common/util/util-dates";
import {
    createThirdResource,
    deleteThirdResource,
    getThirdResource,
    updateThirdResource
} from "../../../../data/actions/thirdResource";
import TableFilters from "../../../../common/components/resource-table/table-components/table-filters";

export default class TruckPayrollAdjustments extends Component {
    constructor(props) {
        super(props)

        this.pagePath = this.props.location.pathname.slice(0, this.props.location.pathname.lastIndexOf('/'))

        this.state = {
            ...DEFAULT_CRUD_STATE,
            fields: this.getFields(),
            canSubmit: false,
            queryFilterFields: this.getQueryFilterFields(),
            queryOneTimeFilterFields: this.getQueryOneTimeFilterFields(),
            dataView: "grid"
        }

        this.state = mergeDeep(this.state, LocalStorage.rehydrateState(this.pagePath))
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        if (this.getID()) {
            this.fetchScheduledData();
            this.fetchOneTimeData();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.deductionData !== this.props.deductionData) {
            this.fetchScheduledData();
            this.fetchOneTimeData();
        }

        if (prevProps.currentView !== this.props.currentView) {
            this.handleSetDataView(this.props.currentView)
        }
    }

    /** Data Events
     ================================================================= */
    fetchScheduledData = () => {
        this.props.dispatch(getSecondResource({
            user: LocalStorage.get('user'),
            query: Object.assign({}, this.getScheduledQuery(), {searchFields: JSON.stringify({DeductionRepeatTypeID: ['DeductionRepeatTypeID', '<>', 4]})}),
            resource: this.getResource()
        }))
    }

    fetchOneTimeData = () => {
        this.props.dispatch(getThirdResource({
            user: LocalStorage.get('user'),
            query: Object.assign({}, this.getOneTimeQuery(), {
                searchFields: JSON.stringify({
                    DeductionRepeatTypeID: 4
                })
            }),
            resource: this.getResource()
        }))
    }

    /** UI Events
     ================================================================= */
    handleSetDataView = (view) => {
        this.setState({dataView: view}, () => {
            this.fetchScheduledData();
            this.fetchOneTimeData();
            LocalStorage.persistState(this.pagePath, this.state, ['dataView']);
        })
    }

    handleToggleScheduledCreateModal = () => {
        this.setState({createScheduledModalOpen: !this.state.createScheduledModalOpen})
    }

    handleToggleScheduledUpdateModal = (item = null) => {
        this.setState({
            updateScheduledModalOpen: !this.state.updateScheduledModalOpen,
            selectedItem: item
        })
    }

    handleToggleConfirmModal = (item = null) => {
        this.setState({
            confirmScheduledModalOpen: !this.state.confirmScheduledModalOpen,
            selectedItem: item
        })
    }

    handleToggleOneTimeConfirmModal = (item = null) => {
        this.setState({
            confirmOneTimeModalOpen: !this.state.confirmOneTimeModalOpen,
            selectedItem: item
        })
    }

    handleToggleOneTimeCreateModal = () => {
        this.setState({createOneTimeModalOpen: !this.state.createOneTimeModalOpen})
    }

    handleToggleOneTimeUpdateModal = (item = null) => {
        this.setState({
            updateOneTimeModalOpen: !this.state.updateOneTimeModalOpen,
            selectedItem: item
        })
    }

    handleInputChange = (fields, name, value) => {
        const fieldsUpdate = FieldsManager.updateField(fields, name, value);
        if (name === 'DeductionRepeatTypeID') {
            if (value === '2') {
                fieldsUpdate.MaxAmount.value = ''
                fieldsUpdate.MaxAmount.disabled = false
            } else {
                fieldsUpdate.MaxAmount.disabled = true
            }
        }

        if (name === 'Deduction') {
            fieldsUpdate.IncomeAccountID.type = value === 1 ? 'select-search' : 'hidden';
            fieldsUpdate.ExpenseAccountID.type = value === 0 ? 'select-search' : 'hidden';
            fieldsUpdate.IncomeAccountID.validate = value === 1 ? ['empty'] : [''];
            fieldsUpdate.ExpenseAccountID.validate = value === 0 ? ['empty'] : [''];
        }
        if (name === 'ScheduledDeductionsType') {
            if (value === 1) {
                fieldsUpdate.Amount.type = 'float'
                fieldsUpdate.AmountPer.type = 'hidden'
                fieldsUpdate.AmountPer.value = ''
            } else {
                fieldsUpdate.AmountPer.type = 'float'
                fieldsUpdate.Amount.type = 'hidden'
                fieldsUpdate.Amount.value = ''
            }
        }
        return fieldsUpdate;
    }
    /** Helpers
     ================================================================= */
    getID = () => {
        return this.props.TruckID
    }

    getResource = () => {
        return Resources.TrucksDeduction
    }

    getScheduledQuery = () => {
        return {
            id: this.getID(),
            limit: 100,
            offset: 0,
            ...FieldsManager.getFieldKeyValues(this.state.queryFilterFields)
        }
    }

    getOneTimeQuery = () => {
        return {
            id: this.getID(),
            limit: 100,
            offset: 0,
            ...FieldsManager.getFieldKeyValues(this.state.queryOneTimeFilterFields)
        }
    }

    getFields = (item = null) => {
        let isScheduled = this.state?.updateScheduledModalOpen || this.state?.createScheduledModalOpen
        let fieldTemplates = {
            Notes: new Field('Notes', '', ['empty'], false, 'text', {
                addContainerClass: 'col-span-full'
            }),
            Deduction: new Field('Deduction', Number(item?.Deduction) === 1 ? 1 : 0, [], false, 'button-group', {
                data: {1: 'Deduction', 0: 'Addition'},
                addContainerClass: 'col-span-full',
                render: (it) => !it.Deduction
                    ? <div className="flex gap-x-2">
                        <PlusCircleIcon className="text-green-600 w-5 h-5"/>
                        {this.props.translate("text.addition")}
                    </div>
                    : <div className="flex gap-x-2">
                        <MinusCircleIcon className="text-red-600 w-5 h-5"/>
                        {this.props.translate("text.deduction")}
                    </div>
            }),
            IncomeAccountID: new Field('IncomeAccountID', '', Number(item?.Deduction) === 1 ? ['empty'] : [''], false, Number(item?.Deduction) !== 1 ? 'hidden' : 'select-search', {
                addContainerClass: 'col-span-full',
                label: "account",
                hideTable: true
            }),
            ExpenseAccountID: new Field('ExpenseAccountID', '', Number(item?.Deduction) === 0 ? ['empty'] : [''], false, Number(item?.Deduction) === 1 ? 'hidden' : 'select-search', {
                addContainerClass: 'col-span-full',
                label: "account",
                render: (it) => it.Deduction ? it.IncomeAccount : it.ExpenseAccount
            }),
            ScheduledDeductionsType: new Field('ScheduledDeductionsType', item?.ScheduledDeductionsType ?? 1, [], false, 'button-group', {
                data: {1: 'Fixed amount', 2: 'Per mile', 3: 'Per gallon'},
                addContainerClass: 'col-span-full',
                render: (item) => (Number(item?.ScheduledDeductionsType) === 1)
                    ? <div className="flex gap-x-2">
                        {this.props.translate("text.fixed_amount")}
                    </div>
                    : (Number(item?.ScheduledDeductionsType) === 2) ? <div className="flex gap-x-2">
                        {this.props.translate("text.per_mile_amount")}
                    </div> : <div className="flex gap-x-2">
                        {this.props.translate("text.per_gallon_amount")}
                    </div>
            }),
            Amount: new Field('Amount', '', [], false, Number(item?.ScheduledDeductionsType ?? 1) === 1 ? 'float' : 'hidden', {
                addContainerClass: 'col-span-full',
                render: (item) => {
                    return formatMoney(!!item?.Amount && !!item?.Amount > 0 ? item?.Amount : item?.AmountPer)
                }
            }),
            AmountPer: new Field('AmountPer', '', [], false, Number(item?.ScheduledDeductionsType ?? 1) !== 1 ? 'float' : 'hidden', {
                addContainerClass: 'col-span-full',
                hideTable: true
            }),
            StartDate: new Field('StartDate', '', ['empty'], false, 'date', {
                addContainerClass: 'col-span-full'
            }),
            ...(item && isScheduled && { LastUsedDate: new Field('LastUsedDate', '', [''], false, 'date', {
                addContainerClass: 'col-span-full'
            })}),
            DeductionRepeatTypeID: new Field('DeductionRepeatTypeID', isScheduled ? '1' : '4', [], false, 'radio', {
                options: isScheduled ? [
                    {name: 'Unlimited', value: '1'},
                    {name: 'Up to the account balance', value: '2'},
                    {name: 'Until account balance reaches zero', value: '3'},
                ] : [
                    {name: 'One time', value: '4'}
                ],
                addContainerClass: 'col-span-full',
                render: (it) => {
                    let text = '';
                    switch (+it.DeductionRepeatTypeID) {
                        case 1:
                            text = 'Unlimited'
                            break;
                        case 2:
                            text = 'Up to the account balance'
                            break;
                        case 3:
                            text = 'Until account balance reaches zero'
                            break;
                        case 4:
                            text = 'One time'
                            break;
                    }
                    return text
                }
            }),
            MaxAmount: new Field('MaxAmount', '', [], true, isScheduled ? 'float' : 'hidden', {
                addContainerClass: 'col-span-full',
                label: "up_to_account_balance",
                render: (it) => {
                    switch (+it.DeductionRepeatTypeID) {
                        case 2:
                            return (numberWithCommas(it.MaxAmount))
                        default:
                            return "/";
                    }
                }
            }),
            ScheduleFrequency: new Field('ScheduleFrequency', "0", ['empty'], false, isScheduled ? 'select' : 'hidden', {
                addContainerClass: 'col-span-full',
                render: (it) => {
                    switch (+it.ScheduleFrequency) {
                        case 1:
                            return "Weekly";
                        case 2:
                            return "Monthly";
                        default:
                            return "Every payroll";
                    }
                }
            }, {
                values: {
                    0: "Every payroll",
                    1: "Weekly",
                    2: "Monthly"
                },
            }),
            Active: new Field('Active', 1, [], false, 'checkbox', {
                addContainerClass: 'col-span-full'
            }),
            Usage: new Field('Usage', "", [], false, 'custom', {
                addContainerClass: 'col-span-full',
                render: (it) => {
                    let text = '';
                    switch (+it.DeductionRepeatTypeID) {
                        case 3:
                        case 2:
                            text = 'Balance ' + numberWithCommas(it.UsedAmount, 2)
                            break;
                        case 1:
                            text = !!it.LastUsedDate ? "Last usage " + toFrontDate(it.LastUsedDate) : "Not used"
                            break;
                        case 4:
                            text = !!it.LastUsedDate ? "Used at " + toFrontDate(it.LastUsedDate) : "Not used"
                            break;
                    }
                    return text
                },
                hideDialog: true
            })
        }

        if (item) {
            if (item.ScheduleFrequency == 0) {
                item.ScheduleFrequency = "0";
            }
            fieldTemplates = fillFieldsFromData(fieldTemplates, item)
            switch (+item.DeductionRepeatTypeID) {
                case 2:
                    fieldTemplates.MaxAmount.disabled = false
                    break;
                default:
                    fieldTemplates.MaxAmount.disabled = true
            }
        } else {
            fieldTemplates.ExpenseAccountID.validate = ['empty'];
        }

        return fieldTemplates
    }

    getQueryFilterFields = () => {
        return {
            query: new Field('query', '', [''], false, 'search')
        }
    }

    getQueryOneTimeFilterFields = () => {
        return {
            query: new Field('query', '', [''], false, 'search'),
            NotUsed: new Field('NotUsed', '1', [], false, 'checkbox')
        }
    }

    handleFilterInputChange = (name, value) => {
        this.setState({
            queryFilterFields: FieldsManager.updateField(this.state.queryFilterFields, name, value),
            offset: 0
        }, () => {
            this.fetchScheduledData();
        })
    }

    handleFilterOneTimeInputChange = (name, value) => {
        this.setState({
            queryOneTimeFilterFields: FieldsManager.updateField(this.state.queryOneTimeFilterFields, name, value),
            offset: 0
        }, () => {
            this.fetchOneTimeData();
        })
    }

    render() {
        const {translate, secondResource, thirdResource, payAdjustments} = this.props

        // payAdjustments is the state of list of created adjustments in create truck mode
        const data = payAdjustments.length ? payAdjustments : getProp(secondResource, 'data.list', []);
        const isLoading = secondResource.isLoading;

        const thirdData = getProp(thirdResource, 'data.list', []);
        const thirdIsLoading = thirdResource.isLoading;
        const oneTimeNotUsedAmount = getProp(thirdResource, 'data.NotUsedAmount', '');
        const isCreateMode = !this.getID();

        const metadata = {
            IncomeAccountID: {
                api: 'api/' + Resources.AccountsQuick,
                query: {
                    limit: 20,
                    offset: 0,
                    IncomeLiabilityAccounts: 1
                },
                searchMap: (item) => ({
                    label: item.AccountNumber + ' ' + item.AccountName,
                    value: item.AccountID
                })
            },
            ExpenseAccountID: {
                api: 'api/' + Resources.AccountsQuick,
                query: {
                    limit: 20,
                    offset: 0,
                    ExpenseAdvancesAccounts: 1
                },
                searchMap: (item) => ({
                    label: item.AccountNumber + ' ' + item.AccountName,
                    value: item.AccountID
                })
            }
        }

        return (
            <div className="space-y-4 flex flex-col">
                <PageHeader
                    title={translate('title.scheduled_deductions')}
                    titleClass="ml-2 text-2xl mt-4"
                    className="flex h-9"
                    buttonLabel={translate('btn.create_new')}
                    onButtonClick={this.handleToggleScheduledCreateModal}
                    buttonHidden={!checkPerm(this.getResource(), CREATE_PERM) || this.props.visible}
                />
                <Card addClass={"flex-shrink-1 min-h-[33.5rem]"} bodyClass="overflow-hidden">
                    {/*<div className={*/}
                    {/*    classNames(*/}
                    {/*        "space-y-4 rounded-card shadow-sm min-h-[33.5rem]",*/}
                    {/*        (data.length === 0) && !isLoading ? "flex items-center justify-center" : undefined*/}
                    {/*    )*/}
                    {/*}>*/}
                    <div>
                        <TableFilters
                            hideLimit
                            filterFields={this.state.queryFilterFields}
                            handleInputChange={this.handleFilterInputChange}
                            translate={translate}
                            onRefreshTable={this.fetchScheduledData}
                            isLoading={isLoading}
                        />

                        <ResourceTable
                            data={data}
                            fields={this.getFields()}

                            options={{
                                style: {
                                    verticalLines: true,
                                    stripedRows: true,
                                    condensed: true,
                                    floatingActions: true
                                },
                                classes: {
                                    headerTextClass: 'text-xs font-semibold text-tm-gray-900 capitalize',
                                    primaryTextClass: ''
                                }
                            }}

                            translate={translate}
                            isLoading={isLoading}

                            onRowClick={(item) => checkPerm(this.getResource(), UPDATE_PERM) && !this.props.visible && this.handleToggleScheduledUpdateModal(item)}
                            actions={[
                                {
                                    action: this.handleToggleScheduledUpdateModal,
                                    icon: PencilIcon,
                                    visible: () => checkPerm(this.getResource(), UPDATE_PERM) && !this.props.visible,
                                    title: translate('text.show_details'),
                                },
                                {
                                    action: this.handleToggleConfirmModal,
                                    icon: TrashIcon,
                                    visible: () => checkPerm(this.getResource(), DELETE_PERM) && !this.props.visible,
                                    title: translate('text.delete_item'),
                                }
                            ]}
                        />

                        <NoRecordsTable
                            show={(data.length === 0) && !isLoading}
                            title={translate('text.no_matching_records')}
                            className={"pb-12 pt-16 px-6"}
                        />
                    </div>

                    <ModalSaveResource
                        title={translate('dialog_heading.edit_truck_deduction')}
                        widthClass="max-w-md"
                        gridColsClass="grid-cols-12"
                        show={this.state.updateScheduledModalOpen}
                        onClose={() => this.handleToggleScheduledUpdateModal()}
                        fields={this.getFields(this.state.selectedItem)}

                        onSubmit={(params) => {
                            if (params) {
                                params.IsForever = params.DeductionRepeatTypeID == '1' ? 1 : 0
                                if (params.DeductionRepeatTypeID == '4') {
                                    params.MaxAmount = params.ScheduledDeductionsType == 1 ? params.Amount : params.AmountPer
                                }
                                this.props.dispatch(updateSecondResource({
                                    user: LocalStorage.get('user'),
                                    params: Object.assign(params, {
                                        TruckID: this.getID(),
                                        TruckScheduledDeductionsID: this.state.selectedItem.TruckScheduledDeductionsID,
                                    }),
                                    query: Object.assign({}, this.getScheduledQuery(), {searchFields: JSON.stringify({DeductionRepeatTypeID: ['DeductionRepeatTypeID', '<>', 4]})}),
                                    resource: this.getResource(),
                                    piggyResource: this.getResource(),
                                    errorMessage: true, successMessage: translate('text.truck_deduction_updated')
                                }))
                                this.handleToggleScheduledUpdateModal()
                            }
                        }}
                        translate={translate}
                        metadata={metadata}
                        handleInputChange={this.handleInputChange}
                    />

                    <ModalSaveResource
                        title={translate('dialog_heading.create_truck_deduction')}
                        widthClass="max-w-md"
                        gridColsClass="grid-cols-12"
                        show={this.state.createScheduledModalOpen}
                        onClose={() => this.handleToggleScheduledCreateModal()}
                        fields={this.getFields()}
                        onSubmit={(params) => {
                            if (params && !isCreateMode) {
                                params.IsForever = params.DeductionRepeatTypeID == '1' ? 1 : 0
                                params.TruckID = this.getID()
                                this.props.dispatch(createSecondResource({
                                    user: LocalStorage.get('user'),
                                    query: Object.assign({}, this.getScheduledQuery(), {searchFields: JSON.stringify({DeductionRepeatTypeID: ['DeductionRepeatTypeID', '<>', 4]})}),
                                    params: params,
                                    resource: this.getResource(),
                                    piggyResource: this.getResource(),
                                    errorMessage: true, successMessage: translate('text.truck_deduction_created')
                                }))
                                this.handleToggleScheduledCreateModal();
                            }
                        }}
                        translate={translate}
                        metadata={metadata}
                        handleInputChange={this.handleInputChange}
                    />

                    <ModalConfirm
                        title={translate('text.Confirm')}
                        show={!!this.state.confirmScheduledModalOpen}
                        text={translate('message.confirm_delete_deduction')}
                        onClose={() => this.handleToggleConfirmModal()}
                        buttonLabel={translate('btn.confirm')}
                        closeButtonLabel={translate('btn.cancel')}
                        translate={translate}
                        onConfirm={() => {
                            this.props.dispatch(deleteSecondResource({
                                user: LocalStorage.get('user'),
                                query: Object.assign(
                                    {TruckScheduledDeductionsID: this.state.selectedItem.TruckScheduledDeductionsID},
                                    this.getScheduledQuery()
                                ),
                                secondPiggyQuery: Object.assign({}, this.getScheduledQuery(), {searchFields: JSON.stringify({DeductionRepeatTypeID: ['DeductionRepeatTypeID', '<>', 4]})}),
                                resource: this.getResource(),
                                secondPiggyResource: this.getResource(),
                                errorMessage: true, successMessage: translate('text.truck_deduction_deleted')
                            }))
                            this.handleToggleConfirmModal()
                        }}
                    />
                </Card>

                <div className="space-y-4 flex flex-col">
                    <PageHeader
                        title={translate('title.one_time_deductions')}
                        titleClass="ml-2 text-2xl mt-4"
                        className="flex h-9"
                        buttonLabel={translate('btn.create_new')}
                        afterTitle={" - Not used amount: " + oneTimeNotUsedAmount}
                        onButtonClick={this.handleToggleOneTimeCreateModal}
                        buttonHidden={!checkPerm(this.getResource(), CREATE_PERM) || this.props.visible}
                    />
                    <Card addClass={"flex-shrink-1 min-h-[33.5rem]"} bodyClass="overflow-hidden">
                        {/*<div className={*/}
                        {/*    classNames(*/}
                        {/*        "space-y-4 rounded-card shadow-sm min-h-[33.5rem]",*/}
                        {/*        (thirdData.length === 0) && !thirdIsLoading ? "flex items-center justify-center" : undefined*/}
                        {/*    )*/}
                        {/*}>*/}
                        <div>
                            <TableFilters
                                hideLimit
                                filterFields={this.state.queryOneTimeFilterFields}
                                handleInputChange={this.handleFilterOneTimeInputChange}
                                translate={translate}
                                onRefreshTable={this.fetchOneTimeData}
                                isLoading={thirdIsLoading}
                            />

                            <ResourceTable
                                data={thirdData}
                                fields={this.getFields()}

                                options={{
                                    style: {
                                        verticalLines: true,
                                        stripedRows: true,
                                        condensed: true,
                                        floatingActions: true
                                    },
                                    classes: {
                                        headerTextClass: 'text-xs font-semibold text-tm-gray-900 capitalize',
                                        primaryTextClass: ''
                                    }
                                }}

                                translate={translate}
                                isLoading={thirdIsLoading}

                                onRowClick={(item) => checkPerm(this.getResource(), UPDATE_PERM) && !this.props.visible && this.handleToggleOneTimeUpdateModal(item)}
                                actions={[
                                    {
                                        action: this.handleToggleOneTimeUpdateModal,
                                        icon: PencilIcon,
                                        visible: () => checkPerm(this.getResource(), UPDATE_PERM) && !this.props.visible,
                                        title: translate('text.show_details'),
                                    },
                                    {
                                        action: this.handleToggleOneTimeConfirmModal,
                                        icon: TrashIcon,
                                        visible: () => checkPerm(this.getResource(), DELETE_PERM) && !this.props.visible,
                                        title: translate('text.delete_item'),
                                    }
                                ]}
                            />

                            <NoRecordsTable
                                show={(thirdData.length === 0) && !thirdIsLoading}
                                title={translate('text.no_matching_records')}
                                className={"pb-12 pt-16 px-6"}
                            />
                        </div>

                        <ModalSaveResource
                            title={translate('dialog_heading.edit_one_time_deduction')}
                            widthClass="max-w-md"
                            gridColsClass="grid-cols-12"
                            show={this.state.updateOneTimeModalOpen}
                            onClose={() => this.handleToggleOneTimeUpdateModal()}
                            fields={this.getFields(this.state.selectedItem)}

                            onSubmit={(params) => {
                                if (params) {
                                    params.IsForever = params.DeductionRepeatTypeID == '1' ? 1 : 0
                                    if (params.DeductionRepeatTypeID == '4') {
                                        params.MaxAmount = params.ScheduledDeductionsType == 1 ? params.Amount : params.AmountPer
                                    }
                                    this.props.dispatch(updateThirdResource({
                                        user: LocalStorage.get('user'),
                                        params: Object.assign(params, {
                                            TruckID: this.getID(),
                                            TruckScheduledDeductionsID: this.state.selectedItem.TruckScheduledDeductionsID,
                                        }),
                                        query: Object.assign({}, this.getOneTimeQuery(), {
                                            searchFields: JSON.stringify({
                                                DeductionRepeatTypeID: 4
                                            })
                                        }),
                                        resource: this.getResource(),
                                        piggyResource: this.getResource(),
                                        errorMessage: true,
                                        successMessage: translate('text.truck_one_time_deduction_updated')
                                    }))
                                    this.handleToggleOneTimeUpdateModal()
                                }
                            }}
                            translate={translate}
                            metadata={metadata}
                            handleInputChange={this.handleInputChange}
                        />

                        <ModalSaveResource
                            title={translate('dialog_heading.create_one_time_deduction')}
                            widthClass="max-w-md"
                            gridColsClass="grid-cols-12"
                            show={this.state.createOneTimeModalOpen}
                            onClose={() => this.handleToggleOneTimeCreateModal()}
                            fields={this.getFields()}
                            onSubmit={(params) => {
                                if (params && !isCreateMode) {
                                    params.IsForever = params.DeductionRepeatTypeID == '1' ? 1 : 0
                                    params.TruckID = this.getID()
                                    this.props.dispatch(createThirdResource({
                                        user: LocalStorage.get('user'),
                                        query: Object.assign({}, this.getOneTimeQuery(), {
                                            searchFields: JSON.stringify({
                                                DeductionRepeatTypeID: 4
                                            })
                                        }),
                                        params: params,
                                        resource: this.getResource(),
                                        piggyResource: this.getResource(),
                                        errorMessage: true,
                                        successMessage: translate('text.truck_one_time_deduction_created')
                                    }))
                                    this.handleToggleOneTimeCreateModal();
                                }
                            }}
                            translate={translate}
                            metadata={metadata}
                            handleInputChange={this.handleInputChange}
                        />

                        <ModalConfirm
                            title={translate('text.Confirm')}
                            show={!!this.state.confirmOneTimeModalOpen}
                            text={translate('message.confirm_delete_deduction')}
                            onClose={() => this.handleToggleOneTimeConfirmModal()}
                            buttonLabel={translate('btn.confirm')}
                            closeButtonLabel={translate('btn.cancel')}
                            translate={translate}
                            onConfirm={() => {
                                this.props.dispatch(deleteThirdResource({
                                    user: LocalStorage.get('user'),
                                    query: Object.assign(
                                        {TruckScheduledDeductionsID: this.state.selectedItem.TruckScheduledDeductionsID},
                                        this.getOneTimeQuery()
                                    ),
                                    piggyQuery: Object.assign({}, this.getOneTimeQuery(), {
                                        searchFields: JSON.stringify({
                                            DeductionRepeatTypeID: 4
                                        })
                                    }),
                                    resource: this.getResource(),
                                    piggyResource: this.getResource(),
                                    errorMessage: true,
                                    successMessage: translate('text.truck_one_time_deduction_deleted')
                                }))
                                this.handleToggleOneTimeConfirmModal()
                            }}
                        />
                    </Card>

                    <InfoParagraph type="info" className={"m-4"}>
                        <p>{"Payroll adjustment entries will appear on "} <Link to={`/driver-payroll`}
                                                                                className={"text-primary underline"}>payroll
                            record.</Link> {"Serving as a template for recurring charges or additions, these entries can be edited or selectively added to each payroll record."}
                        </p>
                    </InfoParagraph>
                </div>
            </div>
        )
    }
}
